import { Box, Button, useTheme } from "@mui/material";
import moment from "moment";
import { useRouter } from "next/router";
import React from "react";
import { FormattedMessage } from "react-intl";
import { eventTracking } from "../../../../firebase/firebaseConfig";
import { TTheme } from "../../../../utils/configs/setupTheme";
import { OPENING_VIEW_TYPE_QUIZ_PDF } from "../../../../utils/constants/constants";
import AnswerNormalQuizBoard from "./AnswerNormalQuizBoard";
import CountdownStartTime from "./CountdownStartTime";
import { AnswerQuizPDF } from "./DisplayQuizPDF";
import FormatTimePractice from "./FormatTimePractice";

export default function AnswerBoard({
  checkCountResult,
  quizInfoStart,
  answerTotal,
  startTime,
  endTime,
  isArena,
  quizDetail,
  setOpenAlertDialogTimeOut,
  arrayQuizData,
  chooseAnswerOfOneAnswerQuestion,
  chooseAnswerOfManyAnswerQuestion,
  setOpenSubmitDialog,
  scrollFunc,
  isDialog
}: any) {
  const theme: TTheme = useTheme();
  const router = useRouter();
  return (
    <Box className={`card-side md:w-[250px] lg:w-[298px] py-4  ${isDialog ? "px-2" : "md:px-0 lg:px-2"}`}>
      {isDialog ? (
        <span className="border-b border-gray flex justify-center pb-2 font-semibold">
          <FormattedMessage id="quiz.answer.title" />
        </span>
      ) : (
        <Box
          style={{
            display: "flex",
            justifyContent: "space-around",
            borderBottom: `1px solid ${theme.palette.primary.gray}`,
            paddingBottom: 8
          }}
        >
          <Box className="center-col font-semibold text-[15px]">
            <span className="text-blackQuiz">
              <FormattedMessage id="IDS_Number_Questions_Did" />
            </span>
            <Box className="center-row" style={{ color: "#1B8F00" }}>
              <span className="text-[23px] font-[500] mt-[6px]">
                {checkCountResult(answerTotal)}/{quizInfoStart?.question_ids?.length || 0}
              </span>
            </Box>
          </Box>
          <Box
            style={{
              borderRight: `1px solid ${theme.palette.primary.gray}`,
              height: 62
            }}
          />
          <Box
            style={{
              height: 62,
              paddingRight: 8
            }}
            className="font-semibold text-[15px]"
          >
            <span className="text-blackQuiz">
              {quizInfoStart?.time > 0 && startTime > 0 ? (
                <FormattedMessage id="IDS_Remain_Times" />
              ) : (
                <FormattedMessage id="ResultQuizzes.timeQuizz" />
              )}
            </span>
            <Box className="center-row text-[23px] mt-2 text-[#1B8F00] font-medium">
              {startTime &&
                (quizInfoStart?.time > 0 ? (
                  <CountdownStartTime
                    startTime={startTime}
                    endTime={endTime}
                    quizTime={quizInfoStart?.time}
                    isArena={isArena}
                    onComplete={() => setOpenAlertDialogTimeOut(true)}
                    isQuizTime
                  />
                ) : (
                  <FormatTimePractice
                    time={moment().unix() - moment(startTime).unix()}
                    setOpenAlertDialogTimeOut={setOpenAlertDialogTimeOut}
                  />
                ))}
            </Box>
          </Box>
        </Box>
      )}

      {quizDetail?.opening_view_type === OPENING_VIEW_TYPE_QUIZ_PDF ? (
        <AnswerQuizPDF
          dataList={arrayQuizData}
          answerTotal={answerTotal}
          chooseAnswerOfOneAnswerQuestion={chooseAnswerOfOneAnswerQuestion}
          chooseAnswerOfManyAnswerQuestion={chooseAnswerOfManyAnswerQuestion}
        />
      ) : (
        <AnswerNormalQuizBoard
          dataList={arrayQuizData}
          answerTotal={answerTotal}
          scrollFunc={scrollFunc}
          isDialog={isDialog}
        />
      )}
      <Box className="flex flex-col mt-4">
        <div className="flex gap-6 text-[13px] font-[500]">
          <Box className="flex items-center">
            <Box className="bg-white border rounded-full h-[24px] min-w-[24px] border-gray" />
            <span style={{ marginLeft: 4 }}>
              <FormattedMessage id="IDS_Questions_NotYet" />
            </span>
          </Box>
          <Box className="flex items-center">
            <Box className="bg-white border rounded-full h-[24px] min-w-[24px] border-greenQuiz" />
            <span style={{ marginLeft: 4 }}>
              <FormattedMessage id="IDS_Questions_Did" />
            </span>
          </Box>
        </div>

        <Box className="center-row" mt={2}>
          <Button
            onClick={() => {
              eventTracking(
                router?.pathname?.includes("de-thi") ? "select_exam_submit" : "select_practice_submit",
                {},
                () => {
                  setOpenSubmitDialog(true);
                }
              );
            }}
            className="w-[150px] h-[44px] rounded-[100px] bg-green-gradient"
          >
            <span className="text-white font-semibold">
              <FormattedMessage id="Question.submit" />
            </span>
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
